import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';

const HugeDataTitle = ({
    data,
    dataType,
}) => (
    <>
        <Typography gutterBottom display="inline" variant="h1" component="span">
            {data}
        </Typography>
        <Typography gutterBottom display="inline" variant="h5" component="span">
            {` ${dataType.toLowerCase()}`}
        </Typography>
    </>
);

HugeDataTitle.propTypes = {
    data: PropTypes.string.isRequired,
    dataType: PropTypes.string.isRequired,
};

export default HugeDataTitle;
